import {React, useEffect, useState}  from 'react';
import { 
  FaShoppingCart, FaStoreAltSlash, FaHandHoldingUsd, FaHandHoldingHeart, 
  FaWallet, FaCalendarAlt, FaChartLine, FaClock, 
  FaExclamationTriangle, FaGem, FaStar, 
  FaCrown, FaChartPie, FaBell, FaUserClock, 
  FaArrowUp, FaArrowDown
} from "react-icons/fa";
import { Link } from 'react-router-dom';
import axios from 'axios';
import CustomerChart from './Charts/CustomerChart';
import ProductChart from './Charts/ProductChart';
import MonthlyChart from './Charts/MonthlyChart';
import WeeklyChart from './Charts/WeeklyChart';
import { useStateContext } from './Context/ContextProvider';
import CustomerTable from './Dashboard Items/CustomerTable';

function Dashboard() {
  const [Stores, setStores] = useState([]);
  const [topCustomers, settopCustomers] = useState([]);
  const [monthwise, setmonthwise] = useState([]);
  const [productsdata, setproductsdata] = useState([]);
  const [weeklysale, setweeklysale] = useState([]);
  const [dailyExpense, setDailyExpense] = useState('0');
  const [monthlyExpense, setMonthlyExpense] = useState('0');
  const [dailyWasooli, setDailyWasooli] = useState('0');
  const [monthlyWasooli, setMonthlyWasooli] = useState('0');
  const [dailyUdhar, setDailyUdhar] = useState('0');
  const [monthlyUdhar, setMonthlyUdhar] = useState('0');
  const [Loading, setLoading] = useState(true);
  const { type } = useStateContext();
  const [inactiveCustomers, setInactiveCustomers] = useState([]);
  const [defaulters, setDefaulters] = useState([]);
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      setCurrentTime(now.toLocaleTimeString('en-US', { 
        hour: '2-digit', 
        minute: '2-digit',
        second: '2-digit'
      }));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    axios.get('/sanctum/csrf-cookie').then(response => {
      axios.get('/api/home').then(res => {
        setStores(res.data.stores);
        setmonthwise(res.data.monthwise);
        settopCustomers(res.data.customerwise);
        setproductsdata(res.data.productsdata);
        setweeklysale(res.data.weeklysale);
        setMonthlyExpense(res.data.monthlyTotalExpense);
        setDailyExpense(res.data.dailyExpense);
        setDailyWasooli(res.data.dailyTotalWasooli);
        setMonthlyWasooli(res.data.monthlyTotalWasooli);
        setDailyUdhar(res.data.dailyUdhar);
        setMonthlyUdhar(res.data.monthlyUdhar);
        setInactiveCustomers(res.data.inactiveCustomers);
        setDefaulters(res.data.defaulters);
        setLoading(false);
      });
    });
  }, []);

  const styles = `
    /* Base Styles */
    .dash-container {
      background:white;
      min-height: 100vh;
      padding: 24px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    }

    .dash-content {
      max-width: 1440px;
      margin: 0 auto;
    }

    /* Header */
    .dash-header {
      background: #ffffff;
      border-radius: 16px;
      padding: 24px 32px;
      margin-bottom: 24px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.06);
      border: 1px solid #e8ecf0;
    }

    .dash-header-inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    }

    .dash-header-left {
      flex: 1;
    }

    .dash-header-title {
      font-size: clamp(1.4rem, 2.5vw, 2rem);
      font-weight: 600;
      color: #1a2332;
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 0 0 4px 0;
      letter-spacing: -0.3px;
    }

    .dash-header-icon {
      color: #4a6cf7;
      font-size: clamp(1.4rem, 2.5vw, 2rem);
    }

    .dash-header-subtitle {
      color: #7a8a9e;
      font-size: clamp(0.8rem, 1vw, 0.9rem);
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0;
    }

    .dash-header-right {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
    }

    .dash-badge {
      background: #f8f9fc;
      border: 1px solid #e8ecf0;
      padding: 8px 16px;
      border-radius: 8px;
      color: #4a5a6e;
      font-size: 0.8rem;
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 500;
    }

    .dash-badge-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #34c759;
      animation: pulse-dot 2s infinite;
    }

    .dash-badge-time {
      background: #f8f9fc;
      border: 1px solid #e8ecf0;
      padding: 8px 16px;
      border-radius: 8px;
      color: #4a5a6e;
      font-size: 0.8rem;
      display: flex;
      align-items: center;
      gap: 8px;
      font-variant-numeric: tabular-nums;
    }

    /* Store Grid */
    .dash-store-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
      gap: 12px;
      margin-bottom: 24px;
    }

    .dash-store-item {
      background: #ffffff;
      padding: 14px 12px;
      border-radius: 12px;
      text-align: center;
      transition: all 0.25s ease;
      box-shadow: 0 1px 3px rgba(0,0,0,0.06);
      border: 1px solid #e8ecf0;
      cursor: pointer;
    }

    .dash-store-item:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 16px rgba(74, 108, 247, 0.12);
      border-color: #4a6cf7;
    }

    .dash-store-link {
      color: #1a2332;
      text-decoration: none;
      font-weight: 500;
      font-size: clamp(0.75rem, 0.9vw, 0.85rem);
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }

    .dash-store-icon {
      font-size: clamp(14px, 1.6vw, 18px);
      color: #4a6cf7;
    }

    /* ===== UPDATED STATS GRID ===== */
    .dash-stats-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 16px;
      margin-bottom: 24px;
    }

    .dash-stat-card {
      background: #ffffff;
      border-radius: 16px;
      padding: 20px 24px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
      border: 1px solid #e8ecf0;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
    }

    .dash-stat-card::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
    }

    .dash-stat-card:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
    }

    /* Card-specific top borders */
    .dash-stat-wasooli::before {
      background: linear-gradient(90deg, #4CAF50, #66BB6A);
    }

    .dash-stat-udhar::before {
      background: linear-gradient(90deg, #EF4444, #F87171);
    }

    .dash-stat-expense::before {
      background: linear-gradient(90deg, #6366F1, #818CF8);
    }

    .dash-stat-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
    }

    .dash-stat-icon-wrap {
      width: 42px;
      height: 42px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.1rem;
      color: #fff;
    }

    .dash-stat-wasooli .dash-stat-icon-wrap {
      background: linear-gradient(135deg, #4CAF50, #43A047);
    }

    .dash-stat-udhar .dash-stat-icon-wrap {
      background: linear-gradient(135deg, #EF4444, #DC2626);
    }

    .dash-stat-expense .dash-stat-icon-wrap {
      background: linear-gradient(135deg, #6366F1, #4F46E5);
    }

    .dash-stat-badge {
      font-size: 0.6rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      padding: 3px 12px;
      border-radius: 20px;
      background: #f1f3f5;
      color: #6B7280;
    }

    .dash-stat-wasooli .dash-stat-badge {
      background: #E8F5E9;
      color: #2E7D32;
    }

    .dash-stat-udhar .dash-stat-badge {
      background: #FEE2E2;
      color: #991B1B;
    }

    .dash-stat-expense .dash-stat-badge {
      background: #EEF2FF;
      color: #3730A3;
    }

    .dash-stat-content {
      margin-bottom: 8px;
    }

    .dash-stat-label {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 0.75rem;
      font-weight: 500;
      color: #6B7280;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }

    .stat-trend-icon {
      font-size: 0.6rem;
    }

    .stat-trend-icon.up {
      color: #4CAF50;
    }

    .stat-trend-icon.down {
      color: #EF4444;
    }

    .stat-icon {
      font-size: 0.65rem;
      opacity: 0.6;
    }

    .dash-stat-value {
      font-size: 1.6rem;
      font-weight: 700;
      color: #1A2332;
      margin-top: 2px;
      letter-spacing: -0.3px;
    }

    .dash-stat-wasooli .dash-stat-value {
      color: #2E7D32;
    }

    .dash-stat-udhar .dash-stat-value {
      color: #991B1B;
    }

    .dash-stat-expense .dash-stat-value {
      color: #3730A3;
    }

    .dash-stat-divider {
      height: 1px;
      background: linear-gradient(to right, #e8ecf0, transparent);
      margin: 10px 0 12px 0;
    }

    .dash-stat-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .dash-stat-footer .dash-stat-label {
      font-size: 0.65rem;
      color: #9CA3AF;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }

    .dash-stat-sub {
      font-size: 1.05rem;
      font-weight: 600;
      color: #1A2332;
    }

    .dash-stat-wasooli .dash-stat-sub {
      color: #2E7D32;
    }

    .dash-stat-udhar .dash-stat-sub {
      color: #991B1B;
    }

    .dash-stat-expense .dash-stat-sub {
      color: #3730A3;
    }

    /* Responsive Stats */
    @media (max-width: 992px) {
      .dash-stats-grid {
        gap: 12px;
      }
    }

    @media (max-width: 768px) {
      .dash-stats-grid {
        grid-template-columns: 1fr;
        gap: 10px;
      }
      .dash-stat-card {
        padding: 16px 20px;
      }
      .dash-stat-value {
        font-size: 1.4rem;
      }
      .dash-stat-sub {
        font-size: 0.95rem;
      }
    }

    @media (max-width: 576px) {
      .dash-stat-card {
        padding: 14px 16px;
        border-radius: 12px;
      }
      .dash-stat-value {
        font-size: 1.2rem;
      }
      .dash-stat-sub {
        font-size: 0.85rem;
      }
      .dash-stat-icon-wrap {
        width: 36px;
        height: 36px;
        font-size: 0.9rem;
      }
    }

    /* Section Title */
    .dash-section-title {
      font-size: clamp(0.95rem, 1.2vw, 1.1rem);
      font-weight: 600;
      color: #1a2332;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .dash-section-icon {
      color: #4a6cf7;
      font-size: 1.2rem;
    }

    /* Chart Container */
    .dash-chart-box {
      background: #ffffff;
      border-radius: 16px;
      padding: 18px 20px 20px 20px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.06);
      border: 1px solid #e8ecf0;
      margin-bottom: 16px;
      min-height: 260px;
      transition: all 0.25s ease;
    }

    .dash-chart-box:hover {
      box-shadow: 0 4px 16px rgba(0,0,0,0.08);
    }

    /* Grids */
    .dash-grid-2 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 0px;
      margin-bottom: 16px;
    }

    .dash-grid-4 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
    }

    /* Loading */
    .dash-loading-wrap {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255,255,255,0.95);
      backdrop-filter: blur(8px);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      flex-direction: column;
    }

    .dash-loading-box {
      text-align: center;
      padding: 40px 48px;
      background: #ffffff;
      border-radius: 20px;
      box-shadow: 0 20px 60px rgba(0,0,0,0.08);
      border: 1px solid #e8ecf0;
    }

    .dash-loading-spinner {
      position: relative;
      width: 72px;
      height: 72px;
      margin: 0 auto;
    }

    .dash-loading-ring {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 3px solid transparent;
      border-top: 3px solid #4a6cf7;
      border-bottom: 3px solid #4a6cf7;
      animation: spin 1.2s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;
    }

    .dash-loading-ring-2 {
      width: 80%;
      height: 80%;
      top: 10%;
      left: 10%;
      border-top: 3px solid #8b5cf6;
      border-bottom: 3px solid #8b5cf6;
      animation-direction: reverse;
      animation-duration: 1.5s;
    }

    .dash-loading-title {
      color: #1a2332;
      font-size: clamp(1.2rem, 2vw, 1.5rem);
      font-weight: 600;
      margin-top: 20px;
    }

    .dash-loading-sub {
      color: #7a8a9e;
      font-size: clamp(0.8rem, 1vw, 0.9rem);
      margin-top: 6px;
    }

    /* Animations */
    @keyframes pulse-dot {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.5; transform: scale(0.9); }
    }

    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    @keyframes slideUp {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    .slide-up { animation: slideUp 0.5s ease forwards; }
    .fade-in { animation: fadeIn 0.6s ease forwards; }

    /* Touch-friendly */
    @media (hover: none) {
      .dash-store-item:hover { transform: none; box-shadow: 0 1px 3px rgba(0,0,0,0.06); border-color: #e8ecf0; }
      .dash-stat-card:hover { transform: none; box-shadow: 0 2px 12px rgba(0,0,0,0.06); }
      .dash-chart-box:hover { box-shadow: 0 1px 3px rgba(0,0,0,0.06); }
    }

    /* Responsive */
    @media (max-width: 1200px) {
      .dash-container { padding: 20px; }
    }

    @media (max-width: 992px) {
      .dash-container { padding: 16px; }
      .dash-grid-2 { grid-template-columns: 1fr; gap: 2px; }
      .dash-grid-4 { grid-template-columns: 1fr; gap: 12px; }
    }

    @media (max-width: 768px) {
      .dash-container { padding: 12px; }
      .dash-header { padding: 16px 20px; border-radius: 12px; }
      .dash-header-inner { flex-direction: column; align-items: flex-start; }
      .dash-store-grid { grid-template-columns: repeat(3, 1fr); gap: 8px; }
      .dash-chart-box { padding: 14px; min-height: 200px; }
    }

    @media (max-width: 576px) {
      .dash-container { padding: 8px; }
      .dash-header { padding: 12px 16px; border-radius: 10px; }
      .dash-header-title { font-size: 1.2rem; }
      .dash-header-icon { font-size: 1.2rem; }
      .dash-badge { padding: 5px 12px; font-size: 0.7rem; }
      .dash-badge-time { padding: 5px 12px; font-size: 0.7rem; }
      .dash-store-grid { grid-template-columns: repeat(2, 1fr); gap: 6px; }
      .dash-store-item { padding: 10px 8px; border-radius: 10px; }
      .dash-store-link { font-size: 0.7rem; flex-direction: column; gap: 3px; }
      .dash-store-icon { font-size: 13px; }
      .dash-chart-box { padding: 10px; min-height: 160px; border-radius: 12px; }
      .dash-section-title { font-size: 0.85rem; }
      .dash-loading-box { padding: 24px; margin: 15px; }
      .dash-grid-2 { gap: 2px; }
      .dash-grid-4 { gap: 10px; }
    }

    @media (max-width: 400px) {
      .dash-container { padding: 5px; }
      .dash-header { padding: 10px 12px; border-radius: 8px; }
      .dash-header-title { font-size: 1rem; }
      .dash-store-grid { grid-template-columns: repeat(2, 1fr); gap: 4px; }
      .dash-store-item { padding: 6px 4px; border-radius: 8px; }
      .dash-store-link { font-size: 0.6rem; }
      .dash-chart-box { padding: 6px; min-height: 140px; }
    }

    /* Reduced Motion */
    @media (prefers-reduced-motion: reduce) {
      * { animation-duration: 0.01ms !important; transition-duration: 0.01ms !important; }
    }
  `;

  if (type === 'Salesman') {
    return (
      <div className="dash-container">
        <style>{styles}</style>
        <div className="dash-content">
          <div className="dash-store-grid">
            {Stores.length === 0 ? (
              <center style={{ color: '#4a5a6e', fontSize: '16px', marginTop: '50px' }}>
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p style={{ marginTop: '12px', fontSize: '14px' }}>Loading Stores...</p>
              </center>
            ) : (
              Stores.map((item) => (
                <div className="dash-store-item" key={item.id}>
                  <Link to={`/productdetail/${item.id}`} className="dash-store-link">
                    <FaStoreAltSlash className="dash-store-icon" />
                    <span>{item.name}</span>
                  </Link>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dash-container">
      <style>{styles}</style>
      
      <div className="dash-content">
        {/* Header */}
        <div className="dash-header fade-in">
          <div className="dash-header-inner">
            <div className="dash-header-left">
              <h1 className="dash-header-title">
                <FaGem className="dash-header-icon" />
                Dashboard
              </h1>
              <p className="dash-header-subtitle">
                <FaClock style={{ color: '#4a6cf7' }} />
                Welcome back! {currentTime}
              </p>
            </div>
            <div className="dash-header-right">
              <div className="dash-badge">
                <span className="dash-badge-dot"></span>
                Live
              </div>
              <div className="dash-badge-time">
                <FaCalendarAlt />
                {new Date().toLocaleDateString('en-PK', { 
                  weekday: 'short', 
                  year: 'numeric', 
                  month: 'short', 
                  day: 'numeric' 
                })}
              </div>
              <div className="dash-badge">
                <FaBell />
                3
              </div>
            </div>
          </div>
        </div>

        {/* Store Grid */}
        <div className="dash-store-grid slide-up">
          {Stores.map(store => (
            <div className="dash-store-item" key={store.id}>
              <Link to={`/saleentry/${store.id}`} className="dash-store-link">
                <FaShoppingCart className="dash-store-icon" />
                <span>{store.name}</span>
              </Link>
            </div>
          ))}
        </div>

        {Loading ? (
          <div className="dash-loading-wrap">
            <div className="dash-loading-box">
              <div className="dash-loading-spinner">
                <div className="dash-loading-ring"></div>
                <div className="dash-loading-ring dash-loading-ring-2"></div>
              </div>
              <div className="dash-loading-title">Loading Dashboard</div>
              <div className="dash-loading-sub">Please wait while we fetch your data</div>
            </div>
          </div>
        ) : (
          <>
            {/* ===== UPDATED STATS CARDS ===== */}
            <div className="dash-stats-grid slide-up">
              {/* Collection Card */}
              <div className="dash-stat-card dash-stat-wasooli">
                <div className="dash-stat-header">
                  <div className="dash-stat-icon-wrap">
                    <FaHandHoldingUsd />
                  </div>
                  <span className="dash-stat-badge">Today</span>
                </div>
                <div className="dash-stat-content">
                  <div className="dash-stat-label">
                    <FaArrowUp className="stat-trend-icon up" /> Collection
                  </div>
                  <div className="dash-stat-value">Rs {dailyWasooli}</div>
                </div>
                <div className="dash-stat-divider"></div>
                <div className="dash-stat-footer">
                  <div className="dash-stat-label">
                    <FaCalendarAlt className="stat-icon" /> Monthly Collection
                  </div>
                  <div className="dash-stat-sub">Rs {monthlyWasooli}</div>
                </div>
              </div>

              {/* Due Card */}
              <div className="dash-stat-card dash-stat-udhar">
                <div className="dash-stat-header">
                  <div className="dash-stat-icon-wrap">
                    <FaHandHoldingHeart />
                  </div>
                  <span className="dash-stat-badge">Today</span>
                </div>
                <div className="dash-stat-content">
                  <div className="dash-stat-label">
                    <FaArrowDown className="stat-trend-icon down" /> Due
                  </div>
                  <div className="dash-stat-value">Rs {dailyUdhar}</div>
                </div>
                <div className="dash-stat-divider"></div>
                <div className="dash-stat-footer">
                  <div className="dash-stat-label">
                    <FaCalendarAlt className="stat-icon" /> Monthly Due
                  </div>
                  <div className="dash-stat-sub">Rs {monthlyUdhar}</div>
                </div>
              </div>

              {/* Expense Card */}
              <div className="dash-stat-card dash-stat-expense">
                <div className="dash-stat-header">
                  <div className="dash-stat-icon-wrap">
                    <FaWallet />
                  </div>
                  <span className="dash-stat-badge">Today</span>
                </div>
                <div className="dash-stat-content">
                  <div className="dash-stat-label">
                    <FaChartLine className="stat-trend-icon" /> Expense
                  </div>
                  <div className="dash-stat-value">Rs {dailyExpense}</div>
                </div>
                <div className="dash-stat-divider"></div>
                <div className="dash-stat-footer">
                  <div className="dash-stat-label">
                    <FaCalendarAlt className="stat-icon" /> Monthly Expense
                  </div>
                  <div className="dash-stat-sub">Rs {monthlyExpense}</div>
                </div>
              </div>
            </div>

            {/* Customer Tables */}
            <div className="dash-grid-2 slide-up">
              <div>
                <div className="dash-section-title">
                  <FaUserClock className="dash-section-icon" />
                  Inactive Customers (90+ days)
                </div>
                <CustomerTable 
                  customers={inactiveCustomers} 
                  type={1} 
                  heading=''
                />
              </div>
              <div>
                <div className="dash-section-title">
                  <FaExclamationTriangle className="dash-section-icon" />
                  Defaulters (30+ days overdue)
                </div>
                <CustomerTable 
                  customers={defaulters} 
                  type={2} 
                  heading=''
                />
              </div>
            </div>

            {/* Charts */}
            {type !== 'Salesman' && (
              <div className="dash-grid-4 slide-up">
                <div className="dash-chart-box">
                  <div className="dash-section-title">
                    <FaChartLine className="dash-section-icon" />
                    Weekly Sales
                  </div>
                  <WeeklyChart datas={weeklysale} />
                </div>
                <div className="dash-chart-box">
                  <div className="dash-section-title">
                    <FaCrown className="dash-section-icon" />
                    Top Customers
                  </div>
                  <CustomerChart datas={topCustomers} />
                </div>
                <div className="dash-chart-box">
                  <div className="dash-section-title">
                    <FaChartPie className="dash-section-icon" />
                    Monthly Overview
                  </div>
                  <MonthlyChart data={monthwise} />
                </div>
                <div className="dash-chart-box">
                  <div className="dash-section-title">
                    <FaStar className="dash-section-icon" />
                    Top Products
                  </div>
                  <ProductChart data={productsdata} />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Dashboard;